import { useEffect, useState } from 'react';
import Meta from '../components/Meta';
import HomeFooter from '../components/HomeFooter';
import PageHeader from '../components/shell/PageHeader';
import { OrgCard } from '../components/ProfileCards';
import { Link, useParams } from '../util/router';
import { requireAuth } from '../util/auth';
import { getUser } from '../util/util';
import { getFollowingOrgsByUser } from '../util/db';

function FollowingOrgsPage() {
  const { userId } = useParams();
  const [user, setUser] = useState(null);
  const [orgs, setOrgs] = useState(null);

  useEffect(() => {
    getUser(userId).then(setUser).catch(console.error);
    getFollowingOrgsByUser(userId)
      .then(setOrgs)
      .catch(err => {
        console.error(err);
        setOrgs([]);
      });
  }, [userId]);

  return (
    <>
      <Meta title="Following - Showrunner" />
      <PageHeader
        back
        title={user ? `@${user.username} follows` : 'Following'}
        subtitle={orgs ? `${orgs.length} venues` : undefined}
        actions={
          <Link
            to={`/following-shows/${userId}`}
            className="rounded-xl bg-black px-4 py-2 text-sm font-bold text-white hover:bg-slate-800"
          >
            Their shows
          </Link>
        }
      />
      <section className="mx-auto min-h-[60vh] w-full max-w-[90rem] px-4 py-6 md:px-8 md:py-10">
        {orgs === null ? (
          <div className="flex justify-center py-16">
            <span className="loading loading-spinner loading-lg text-secondary-red" />
          </div>
        ) : orgs.length ? (
          <div className="grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-3">
            {orgs.map(org => (
              <OrgCard key={org.org_id} org={org} />
            ))}
          </div>
        ) : (
          <p className="py-16 text-center text-lg text-slate-600">
            Not following any venues yet. Find galleries and institutions in{' '}
            <Link to="/search?type=venue" className="text-secondary-red underline">
              search
            </Link>
            .
          </p>
        )}
      </section>
      <HomeFooter />
    </>
  );
}

export default requireAuth(FollowingOrgsPage);
